import { Component } from '@angular/core';
import { LayoutComponent } from '../layout/layout.component';
import { SessionManagerComponent } from '../session-manager/session-manager.component';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    imports: [LayoutComponent, SessionManagerComponent]
})
export class MainComponent {

}